import React from "react";
import "../styles/components/Header.scss";
import { isMobile } from "react-device-detect";
import { useAppSelector } from "src/redux/hooks";
import { PersistState } from "src/redux/reducers/PersistSlice";
import HeaderLogo from "./HeaderLogo";

export default function IdleUserHeader() {
  const userLanguage: any = useAppSelector(PersistState);
  const positionClass = isMobile ? "header-position-initial" : "header-position-relative";
  return (
    <div className="header">
      <div className={`container ${positionClass}`}>
        <div className="row ">
          <div
            className="col-md-8 col-10 text-start"
            style={{
              height: !isMobile ? "50px" : "48px",
            }}
          >
            <span>
              <HeaderLogo brand={userLanguage.brand}/>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
